export default __webpack_public_path__ + "static/media/something-went-wrong-emoji.bf8134f6.svg";